import request from 'local_modules/request'
import constants from './constants'


const isDev = process.env.WEBPACK === 'site.dev'

const requestWithMock = (url) => {
  if (!url) {
    console.log('No url')
    return Promise.resolve({ data: {}  })
  }
  return (
    request.get(url)
  )
}


export default requestWithMock
